export const SET_LOADING = 'SET_LOADING';
export const GET_LOADING = 'GET_LOADING';

export default {
    namespaced: true,
    state: {
      loading: false,
      }, 
    mutations: {
        [SET_LOADING](state, loading) {
            state.loading = loading
      },
      },
    getters: {
        [GET_LOADING](state) {
          return state.loading
      }
      }     
}